export default __webpack_public_path__ + "static/media/btn.3364b849.png";